export default "__VITE_ASSET__72a8da46__"